import { createZovaComponentPage } from 'zova';

import { ControllerPageHome } from '../../page/home/controller.jsx';

export const ZPageHome = createZovaComponentPage(ControllerPageHome, undefined, undefined);
